import type { CreateClientConfig } from "./sdk/client.gen";
import { BACKEND_URL } from "./utils/config";

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: BACKEND_URL,
});
